import { memo } from 'react';
import { format } from 'date-fns';
import TableContainer from '@mui/material/TableContainer';
import { Typography } from '@components/Typography';
import { Table } from '@components/Table';
import { useTranslation } from '@hooks';
import { analyticsService } from '@services';
import ExportCSV from '@features/Analytics/ExportCSV';
import { PaperStyled, TableStyled } from '../../Feedback/FeedbackTable';
import { getTableBody } from './SocialPostsTableBody';
import { getCollapsibleTableBody } from './CollapsibleRowBody';

export const GetTableHeader = () => {
    const { t } = useTranslation();
    return [
        {
            key: 0,
            width: '5%',
            component: <></>,
        },
        {
            key: 1,
            width: '25%',
            component: (
                <Typography variant="subtitle2" align="left">
                    {t('common.title')}
                </Typography>
            ),
        },
        {
            key: 3,
            width: '14%',
            component: (
                <Typography align="right" variant="subtitle2">
                    {t('AnalyticsSocialPosts.reach')}
                </Typography>
            ),
        },
        {
            key: 4,
            width: '14%',
            component: (
                <Typography align="right" variant="subtitle2">
                    {t('AnalyticsSocialPosts.likes')}
                </Typography>
            ),
        },
        {
            key: 5,
            width: '14%',
            component: (
                <Typography align="right" variant="subtitle2">
                    {t('AnalyticsSocialPosts.comments')}
                </Typography>
            ),
        },
        {
            key: 6,
            width: '14%',
            component: (
                <Typography align="right" variant="subtitle2">
                    {t('AnalyticsSocialPosts.shares')}
                </Typography>
            ),
        },
    ];
};

const CollapsibleRow = ({ data, index }) => {
    return <Table rows={getCollapsibleTableBody(data, index)} />;
};

const SocialPostsTable = memo(({ isLoading, data, filter }) => {
    const { t } = useTranslation();

    const onExport = () =>
        analyticsService.exportAnalyticsCSV(
            {
                ...filter,
                locations: filter.locations.map(item => item.id),
                from: filter.timeframe.start ? format(new Date(filter.timeframe.start), 'yyyy-MM-dd') : null,
                to: filter.timeframe.end ? format(new Date(filter.timeframe.end), 'yyyy-MM-dd') : null,
            },
            'social-posts',
        );
    return (
        <PaperStyled elevation={1}>
            <div
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}
            >
                <Typography variant="title1" sx={{ alignSelf: 'center' }}>
                    {t(`Header.socialPosts`)}
                </Typography>
                <ExportCSV type="social-posts" apiCall={onExport} />
            </div>
            <TableContainer>
                <TableStyled
                    data={data}
                    columnNames={GetTableHeader()}
                    rows={getTableBody(data)}
                    isDataLoading={isLoading}
                    isCollapsible={true}
                    CollapsibleRow={CollapsibleRow}
                />
            </TableContainer>
        </PaperStyled>
    );
});

SocialPostsTable.displayName = 'SocialPostsTable';

export default SocialPostsTable;
